import { FC } from 'react';

import { useAppSelector } from '../../hooks';
import { Interception } from '../../interfaces/interceptions';
import { interceptionsSelector } from '../../store/slices/interception/selectors';

import InterceptionsCard from './InterceptionsCard';

export interface InterceptionsTableProps {
  selectInterception: (interception: Interception) => void;
  openedInterceptionId?: number;
}

const InterceptionsTable: FC<InterceptionsTableProps> = ({
  selectInterception,
  openedInterceptionId,
}) => {
  const interceptions = useAppSelector(interceptionsSelector);
  return (
    <div className="flex flex-col gap-1">
      {interceptions.map((interception) => (
        <div
          key={interception.id}
          onClick={() => selectInterception(interception)}
        >
          <InterceptionsCard
            interception={interception}
            isOpened={openedInterceptionId === interception.id}
          />
        </div>
      ))}
    </div>
  );
};

export default InterceptionsTable;
